// Auto generated file, do not manually modify!
// com.hotpads.capps.client.enums.applicationconfiguration.ApplicationConfigurationCustomQuestion

export enum ApplicationConfigurationCustomQuestion {
  ACCOUNTANT_CONTACT = 'ACCOUNTANT_CONTACT',
  ADDITIONAL_OCCUPANTS = 'ADDITIONAL_OCCUPANTS',
  ATTORNEY_CONTACT = 'ATTORNEY_CONTACT',
  BROKERAGE_CONTACT = 'BROKERAGE_CONTACT',
  EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
  EMPLOYER_CONTACT_INFO = 'EMPLOYER_CONTACT_INFO',
  EMPLOYER_CONTACT_PERMISSION = 'EMPLOYER_CONTACT_PERMISSION',
  ESA_CERTIFICATION_UPLOAD = 'ESA_CERTIFICATION_UPLOAD',
  FINANCIAL_CONTACTS_BUSINESS_ADDRESS = 'FINANCIAL_CONTACTS_BUSINESS_ADDRESS',
  LANDLORD_CONTACT_PERMISSION = 'LANDLORD_CONTACT_PERMISSION',
  LANDLORD_EMAIL = 'LANDLORD_EMAIL',
  LANDLORD_PHONE = 'LANDLORD_PHONE',
  PERSONAL_REFERENCE = 'PERSONAL_REFERENCE',
  PET_PHOTO_UPLOAD = 'PET_PHOTO_UPLOAD',
  VEHICLES = 'VEHICLES',
  VETERINARY_RECORDS_UPLOAD = 'VETERINARY_RECORDS_UPLOAD',
}

export const ApplicationConfigurationCustomQuestion_values = [
  ApplicationConfigurationCustomQuestion.ACCOUNTANT_CONTACT,
  ApplicationConfigurationCustomQuestion.ADDITIONAL_OCCUPANTS,
  ApplicationConfigurationCustomQuestion.ATTORNEY_CONTACT,
  ApplicationConfigurationCustomQuestion.BROKERAGE_CONTACT,
  ApplicationConfigurationCustomQuestion.EMERGENCY_CONTACT,
  ApplicationConfigurationCustomQuestion.EMPLOYER_CONTACT_INFO,
  ApplicationConfigurationCustomQuestion.EMPLOYER_CONTACT_PERMISSION,
  ApplicationConfigurationCustomQuestion.ESA_CERTIFICATION_UPLOAD,
  ApplicationConfigurationCustomQuestion.FINANCIAL_CONTACTS_BUSINESS_ADDRESS,
  ApplicationConfigurationCustomQuestion.LANDLORD_CONTACT_PERMISSION,
  ApplicationConfigurationCustomQuestion.LANDLORD_EMAIL,
  ApplicationConfigurationCustomQuestion.LANDLORD_PHONE,
  ApplicationConfigurationCustomQuestion.PERSONAL_REFERENCE,
  ApplicationConfigurationCustomQuestion.PET_PHOTO_UPLOAD,
  ApplicationConfigurationCustomQuestion.VEHICLES,
  ApplicationConfigurationCustomQuestion.VETERINARY_RECORDS_UPLOAD,
] as const;
